import React from 'react'
import { useTranslation } from 'react-i18next'
import HeadCont from '../../components/common/HeadCont'

const Version = () => {
  const { t } = useTranslation('settings');
  const pleaseupdate = false;
  return (
    <>
      <HeadCont rightIcon={'no icon'} transparent={'on'} title={t('legal.version_management')} underline={true} />
      <section className='mt-14 mb-6 relative px-6 flex flex-col items-center  text-body1_700 text-gray_160'>
        <img src='/images/mobile/home/landing_rev.svg' alt={t('legal.version_image')} className='pt-[94px]' />
        <span className='pt-[42px]'>{pleaseupdate ? "V.1.0" : "V.2.0"}</span>
        <span className='pt-4 pb-12'>{pleaseupdate ? t('legal.update_required') : t('legal.latest_version')}</span>
      </section>
    </>
  )
}

export default Version